export const rejectedPiecesData = [
    {
        id: 1,
        name: "Pièce A",
        operator: "Jean Dupont",
        status: "Rejetée",
    },
    {
        id: 2,
        name: "Pièce B",
        operator: "Marie Curie",
        status: "Rejetée",
    },
    {
        id: 3,
        name: "Pièce C",
        operator: "Paul Martin",
        status: "Rejetée",
    },
];
